import Vue from 'vue';
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex);

var foo = new Vuex.Store(
  {
    state: {
      currentWorksheet: null,
      traineeId: null
  },
    mutations: {
      setWorksheet(state,worksheet) {
        // mutate state
        state.currentWorksheet = worksheet;
      },
      setTrainee(state,id) {
        // mutate state
        state.traineeId = id;
      }
    },
    plugins: [vuexLocal.plugin]
  });

export const store = foo ;





// WEBPACK FOOTER //
// ./src/components/worksheetStore.js